import React from "react";
import Project from "../admin/project/Project";
import Sidebar from "../admin/sidebar/Sidebar";

function AdminProjectPage() {
  return (
    <div>
      <Sidebar />
      <Project />
    </div>
  );
}

export default AdminProjectPage;
